import {
  CreatePackageSubscriptionInput,
  CreatePackageSubscriptionMutationVariables,
  UpdatePackageSubscriptionInput,
  UpdatePackageSubscriptionMutationVariables,
  ListPackageSubscriptionsQueryVariables,
  Tier,
  GetStripeSubscriptionAPIInput,
  GetStripeSubscriptionAPIMutationVariables,
} from "../API";
import { getUserByUsername, getUser } from "./UsersManager";
import API from "@aws-amplify/api";
import { buildVariables } from "../libs/GraphQueryBuilder";
import { mutation, query } from "gql-query-builder";
import { getStripeSubscriptionByUser } from "./PaymentManager";

export async function getSubscribedPackage(userID: string) {
  const stripeSubscription: any = await getStripeSubscriptionByUser(userID);
  const stripeSub = stripeSubscription?.data?.result?.items?.[0];
  if (!stripeSub) return;
  const _variables: GetStripeSubscriptionAPIMutationVariables = {
    input: {
      subscriptionID: stripeSub.subscriptionID,
    },
  };
  const variables = buildVariables<GetStripeSubscriptionAPIMutationVariables>(
    _variables,
    [{ key: "input", name: "GetStripeSubscriptionAPIInput!" }]
  );
  const q = mutation({
    operation: "result: getStripeSubscriptionAPI",
    fields: [],
    variables,
  });
  const res: any = await API.graphql(q);
  return JSON.parse(res.data.result);
}

export async function getPackageByUserID(userID: string) {
  const user: any = await getUser(["id", "tier"], userID);
  console.log("user", userID, user);
  const { tier } = user.data.result;
  return getPackageByTier(tier);
}

export async function getPackageByUser(username: string) {
  const user: any = await getUserByUsername(
    [{ items: ["id", "tier"] }],
    username
  );
  let tier = user.data.result?.items[0]?.tier ?? "FREE";
  return getPackageByTier(tier);
}

export function createPackage(input: CreatePackageSubscriptionInput) {
  const _variables: CreatePackageSubscriptionMutationVariables = {
    input,
  };
  const variables = buildVariables<CreatePackageSubscriptionMutationVariables>(
    _variables,
    [{ key: "input", name: "CreatePackageSubscriptionInput!" }]
  );
  const q = mutation({
    operation: "result: createPackageSubscription",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export function updatePackage(input: UpdatePackageSubscriptionInput) {
  const _variables: UpdatePackageSubscriptionMutationVariables = {
    input,
  };
  const variables = buildVariables<UpdatePackageSubscriptionMutationVariables>(
    _variables,
    [{ key: "input", name: "UpdatePackageSubscriptionInput!" }]
  );
  const q = mutation({
    operation: "result: updatePackageSubscription",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export function listPackages() {
  const _variables: ListPackageSubscriptionsQueryVariables = {};
  const variables = buildVariables<ListPackageSubscriptionsQueryVariables>(
    _variables,
    []
  );
  const q = query({
    operation: "result: listPackageSubscriptions",
    fields: [
      {
        items: [
          "id",
          "tier",
          "price",
          "pollOptionLimit",
          "groupPollAllowed",
          "pledgeAllowed",
          "pledgeChargePercentage",
          "pollDurationLimit",
          "pollResultLiveAllowed",
          "statisticReportAllowed",
          "withdrawalAllowed",
          "extensionPledgeAllowed",
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export async function getPackageByTier(tier: Tier) {
  const _variables: ListPackageSubscriptionsQueryVariables = {
    filter: {
      tier: { eq: tier },
    },
  };
  const variables = buildVariables<ListPackageSubscriptionsQueryVariables>(
    _variables,
    [
      { key: "filter", name: "ModelPackageSubscriptionFilterInput" },
      { key: "tier", name: "ModelTierInput" },
    ]
  );
  const q = query({
    operation: "result: listPackageSubscriptions",
    fields: [
      {
        items: [
          "id",
          "tier",
          "price",
          "pollOptionLimit",
          "groupPollAllowed",
          "pledgeAllowed",
          "pledgeChargePercentage",
          "pollDurationLimit",
          "pollResultLiveAllowed",
          "statisticReportAllowed",
          "withdrawalAllowed",
          "extensionPledgeAllowed",
        ],
      },
    ],
    variables,
  });
  const res: any = await API.graphql(q);
  return res.data?.result?.items[0];
}
